import axios from 'axios';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: REACT_APP_API_URL,
});

export const processImage = async (formData) => {
  try {
    const response = await api.post('/image/process', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: 'Failed to connect to the server' };
  }
};

export default api;
